import React from "react";

function reportError(what) {
  console.log('+++ reportError():')
  console.log(what)
}

class ErrorBoundary extends React.Component {

  componentDidCatch(error, errorInfo) {
    reportError({
      type: "react",
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack
    });
  }

  render() {
    return this.props.children;
  }
}

console.log('+++ Registering window.onerror...')

// window.onerror = (message, source, lineno, colno, error) => {
//   reportError({
//     type: "window.onerror",
//     message,
//     source,
//     lineno,
//     colno,
//     stack: error?.stack
//   });
// };

// window.addEventListener("unhandledrejection", (event) => {
//   reportError({
//     type: "unhandledrejection",
//     message: event.reason?.message || String(event.reason),
//     stack: event.reason?.stack
//   });
// });


export default ErrorBoundary;

